module.exports = __webpack_public_path__ + "img/zone1.d8febed3.png";